export type SendWhen = 'now' | 'evening' | 'tomorrow' | 'custom';

const at = (base: Date, dayOffset: number, hour: number): Date => {
  const d = new Date(base);
  d.setDate(d.getDate() + dayOffset);
  d.setHours(hour, 0, 0, 0);
  return d;
};

/** When to send for a choice in the Send menu: `null` for now, or for a
 *  choice that has no usable time (an empty or unreadable custom time, or
 *  "this evening" once it is past 18:00). */
export function sendAt(when: SendWhen, custom: string, now: Date): Date | null {
  if (when === 'now') return null;
  if (when === 'evening') {
    const evening = at(now, 0, 18);
    return evening.getTime() > now.getTime() ? evening : null;
  }
  if (when === 'tomorrow') return at(now, 1, 8);
  const picked = new Date(custom);
  return custom && !Number.isNaN(picked.getTime()) ? picked : null;
}

/** Whole seconds to hold a message for, rounded up so it never goes early. */
export function holdSeconds(target: Date, now: Date): number {
  return Math.ceil((target.getTime() - now.getTime()) / 1000);
}

/** Whether a send-later time can be held for: at least a minute ahead. */
export function isFuture(target: Date, now: Date): boolean {
  return holdSeconds(target, now) >= 60;
}
